import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material//ArrowDropDown';
import { flowRight } from 'lodash';
import { SELECT_OPTION } from 'common/constants/inputs';
import withAction from 'components/WithAction';
import withDialog from 'components/WithDialog';
import withLink from 'components/WithLink';
import withRequired from 'components/WithRequired';
import withTooltip from 'components/WithTooltip';
import { SelectValueViewerProps } from './SelectionViewer.props';

const SelectValueViewer = (props: SelectValueViewerProps) => {
  const { cell, onDoubleClick, options, defaultLabel = SELECT_OPTION } = props;

  const { columnLegend, insideLedger, dropdown, value: valueCell } = cell;
  // Both the cell and its options map may be updated in place by the workbook.
  let selected = valueCell;
  if (columnLegend || insideLedger || dropdown) {
    selected = options && valueCell ? options[valueCell as string] : defaultLabel;
  }

  let className = 'value-viewer';

  if (cell.readOnly) {
    return (
      <span className={className}>
        <span className="text-cell">{selected}</span>
      </span>
    );
  }

  className = 'select-value-viewer';

  // Custom double click handler for cells not in a spreadsheet component
  const handleDoubleClick = () => {
    const event = new MouseEvent('dblclick', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    document.getElementById(`select-value-viewer-${selected}`)?.dispatchEvent(event);
  };

  return (
    <div
      id={`select-value-viewer-${selected}`}
      role="button"
      className={className}
      tabIndex={0}
      onClick={onDoubleClick || handleDoubleClick}
      onKeyDown={onDoubleClick}>
      <span className="text-cell">{selected}</span>
      <span className="dropdown-icon">
        <ArrowDropDownIcon />
      </span>
    </div>
  );
};

const enhance = flowRight(withTooltip, withDialog, withRequired, withLink, withAction);

export default enhance(SelectValueViewer);
